var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("v-header", {
        scopedSlots: _vm._u([
          {
            key: "collapseBtn",
            fn: function () {
              return [
                _c(
                  "div",
                  {
                    staticClass: "collapse-btn",
                    on: { click: _vm.collapseChage },
                  },
                  [
                    !_vm.getCollapse
                      ? _c("img", {
                          staticClass: "collapse-icon-cls",
                          attrs: {
                            src: require("@/assets/img/icon-pack-down.svg"),
                            width: "100%",
                          },
                        })
                      : _c("img", {
                          staticClass: "collapse-icon-cls",
                          attrs: {
                            src: require("@/assets/img/icon-pack-up.svg"),
                            width: "100%",
                          },
                        }),
                  ]
                ),
              ]
            },
            proxy: true,
          },
        ]),
      }),
      _c("v-sidebar"),
      _c(
        "div",
        {
          staticClass: "content-box",
          class: { "content-collapse": _vm.getCollapse },
        },
        [
          _c("v-tags"),
          _c(
            "div",
            { staticClass: "content" },
            [
              _c(
                "transition",
                { attrs: { name: "move", mode: "out-in" } },
                [_c("router-view")],
                1
              ),
              _c("el-backtop", { attrs: { target: ".content" } }),
            ],
            1
          ),
          _c("v-bottom", {
            attrs: { isCollapse: _vm.getCollapse ? "t" : "f" },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }